export enum PersonalDraftStepsEnum {
  initialStep = 'initial_step',
  personalPhotoAndHobbies = 'personal_photo_and_hobbies',
  personalBodyParameters = 'personal_body_parameters',
  personalHairColor = 'personal_hair_color',
  personalEyeColor = 'personal_eye_color',
  personalBodyArtTypes = 'personal_body_art_types',
  insuranceBase = 'insurance_base',
  share = 'share',
  congratulations = 'congratulations',
}
